'use server'

import { apiRequest, ApiResponse } from '../request'

export type AgendaBlockType =
    | 'VACATION'
    | 'MEETING'
    | 'BREAK'
    | 'HOLIDAY'
    | 'PERSONAL'
    | 'OTHER'

export interface AgendaBlock {
    id: number
    agendaId: number
    type: AgendaBlockType
    title: string
    description?: string
    startDate: string
    endDate: string
    recurring: boolean
    recurringRule?: string
    createdAt: string
    updatedAt: string
    agenda?: {
        id: number
        professional?: {
            id: number
            name: string
        }
    }
}

export interface CreateAgendaBlockData {
    agendaId: number
    type: AgendaBlockType
    title: string
    description?: string
    startDate: string
    endDate: string
    recurring?: boolean
    recurringRule?: string
}

export interface UpdateAgendaBlockData {
    type?: AgendaBlockType
    title?: string
    description?: string
    startDate?: string
    endDate?: string
    recurring?: boolean
    recurringRule?: string
}

export async function getAgendaBlocks(): Promise<ApiResponse<AgendaBlock[]>> {
    return apiRequest<AgendaBlock[]>('agenda-blocks', {})
}

export async function getAgendaBlock(
    id: number
): Promise<ApiResponse<AgendaBlock>> {
    return apiRequest<AgendaBlock>(`agenda-blocks/${id}`, {})
}

export async function getAgendaBlocksByAgenda(
    agendaId: number
): Promise<ApiResponse<AgendaBlock[]>> {
    return apiRequest<AgendaBlock[]>(`agenda-blocks/agenda/${agendaId}`, {})
}

export async function getAgendaBlocksByRange(
    agendaId: number,
    startDate: string,
    endDate: string
): Promise<ApiResponse<AgendaBlock[]>> {
    return apiRequest<AgendaBlock[]>(`agenda-blocks/range/${agendaId}`, {
        params: { startDate, endDate },
    })
}

export async function createAgendaBlock(
    data: CreateAgendaBlockData
): Promise<ApiResponse<AgendaBlock>> {
    return apiRequest<AgendaBlock>('agenda-blocks', { data }, 'post')
}

export async function updateAgendaBlock(
    id: number,
    data: UpdateAgendaBlockData
): Promise<ApiResponse<AgendaBlock>> {
    return apiRequest<AgendaBlock>(`agenda-blocks/${id}`, { data }, 'patch')
}

export async function deleteAgendaBlock(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`agenda-blocks/${id}`, {}, 'delete')
}

export const BLOCK_TYPE_LABELS: Record<AgendaBlockType, string> = {
    VACATION: 'Ferias',
    MEETING: 'Reuniao',
    BREAK: 'Intervalo',
    HOLIDAY: 'Feriado',
    PERSONAL: 'Pessoal',
    OTHER: 'Outro',
}

export const BLOCK_TYPE_OPTIONS = Object.entries(BLOCK_TYPE_LABELS).map(
    ([value, label]) => ({
        value: value as AgendaBlockType,
        label,
    })
)
